module.exports = __webpack_public_path__ + "img/vous_aimeriez_pt.b3a737ec.svg";